/**
 * Firestore rejects `undefined` anywhere in document data. JSON round-trip drops
 * undefined keys from nested objects (e.g. AssetRef optional width/height).
 */
export function scrubForFirestoreValue(value: unknown): unknown {
  if (value === undefined) return undefined;
  if (value === null) return null;
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return value;
  }
  try {
    return JSON.parse(JSON.stringify(value)) as unknown;
  } catch {
    return value;
  }
}
